import '../../css/AddLoadSensorForm.css';
import axios from 'axios';
import React, { useContext, useState } from 'react';
import { IAuth, IConfiguration, IReplaceTrackerForm, IReplaceTrackerFormValidation } from '../../interfaces/interface';
import { IMessageResponse, IMessageSender, IMessageErrorResponse } from '../../interfaces/messageInterface';
import { AppContext } from '../context/AppContext';
import { ReplaceTrackerContext } from '../context/ReplaceTrackerContext';
import FormInternalDivTemplate from '../formTemplate/FormInternalDivTemplate';
import FormSubmitButton from '../formTemplate/FormSubmitButton';
import FormErrorDivTemplate from '../formTemplate/FormErrorDivTemplate';
import FormTemplateLabel from '../formTemplate/FormTemplateLabel';
function ReplaceTrackerForm() {
    const { navBarStatus, config, authorization, disMessage, errorHandlerFunction } = useContext(AppContext); 
    const { Form, formVal, errMessage, blockField, selectDefault } = useContext(ReplaceTrackerContext); 
    const [isNavbarOpen] = navBarStatus;
    const [configuration] :IConfiguration[] = config
    const [ auth ]: IAuth[] = authorization;
    const [formInput]: IReplaceTrackerForm[] = Form;     
    const [,setFormInput]: React.Dispatch<React.SetStateAction<IReplaceTrackerForm>>[] = Form;
    const [displayMessage]: string[] = disMessage;
    const [,setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [formFieldsValid]:IReplaceTrackerFormValidation[] = formVal;
    const [,setFormFieldsValid]:React.Dispatch<React.SetStateAction<IReplaceTrackerFormValidation>>[] = formVal;
    const [assetNamesArr, setAssetNamesArr] = useState<string[]>([]);
    const [oldDeviceIdArr, setOldDeviceIdArr] = useState<string[]>([]);
    const [newDeviceIdArr, setNewDeviceIdArr] = useState<string[]>([]);
    const [defaultSelect, setDefaultSelect] = selectDefault
    const [filedBlock, setFieldBlock] = blockField;
    const [,setErrorMessage]: React.Dispatch<React.SetStateAction<string>>[] = errMessage;
    const errorHandler: (status: number) => string = errorHandlerFunction;  

    const isDisabled = (): boolean => {
        if(displayMessage !== "none" || isNavbarOpen === true) return true
        return false
    }
    const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); 
        console.log(formInput);
        
        if(formValidation()){
            setDisplayMessage("asset-details");
        }
    }
    const formValidation = ():boolean => {
        let isValid = true
        let tempFormFieldsValid = {...formFieldsValid}
        console.log(formInput);
        Object.entries(formInput).forEach(([key, value]) => {
            if(key === "assetName" || key === "oldDeviceId" || key === "newDeviceId" || key === "oldDeviceIdStatus"){
              if(value === ""){
                tempFormFieldsValid[key]= {
                    isValid: false,
                    displayMessage: true,
                    message: "Field cannot be empty"
                  }
                  isValid = false
              }
            }
          })     
        if(!isValid){
            setFormFieldsValid({...tempFormFieldsValid})
        }
        if(!formFieldsValid.assetName.isValid || !formFieldsValid.newDeviceId.isValid){
            isValid = false;
        }
        return isValid;
      
    }   
    const oldDeviceIdChangeHandler = (e:React.ChangeEvent<HTMLInputElement>):void =>  {
        let input = e.target.value.toUpperCase();
        if (/^[0-9a-fA-F]+$/.test(input) || input === ""){      
            if(input.length >= 3 ){    
                let messageBody:IMessageSender  = {
                    type:'getDeviceIDs',
                    userId: auth.username,
                    deviceIdFilter: {
                        Type: "All Trackers",
                        Pattern: input,
                        }     
                }
                /*axios.post('/message',messageBody *//*For Cookie*/
                axios.post('/message',messageBody, auth.header
                ).then(res => {                                
                    if(res.data.status === "OK"){
                        setOldDeviceIdArr(res.data.names);
                        if(res.data.names.includes(input)){
                            getAssetInfo({deviceId: input})
                        }else{      
                            setFieldBlock(false)
                            setFormFieldsValid({
                                ...formFieldsValid,
                                assetName:{
                                    isValid: false,    
                                    displayMessage: false,
                                    message: ""
                                },
                                oldDeviceId:{
                                    isValid: false,    
                                    displayMessage: false,
                                    message: ""
                                },
                            })   
                            if(formInput.assetName !== ""){
                                setFormInput({
                                    ...formInput,
                                    assetName: "",
                                    oldDeviceId: input,
                                })

                            }                                            
                        }
                    }else{
                        setFieldBlock(false)
                        setOldDeviceIdArr([]);
                        setFormFieldsValid({
                            ...formFieldsValid,
                            oldDeviceId:{
                                isValid: false,    
                                displayMessage: true,
                                message: res.data.errorDescription
                            }
                        })
                    }
                }).catch(({response}:IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status)
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                    })
            }else{
                setOldDeviceIdArr([]);
                setFormFieldsValid({
                    ...formFieldsValid,
                    oldDeviceId:{
                        isValid: false,    
                        displayMessage: false,
                        message: ""
                    }
                })
            }
            setFormInput({
            ...formInput,
            oldDeviceId: input
            })
        }
    };
    const assetNameChangeHandler = (e:React.ChangeEvent<HTMLInputElement>):void =>  {
        let input = e.target.value;
        if(!(/'/.test(input)) && !(/"/.test(input)) && !(/`/.test(input))){          
            if(input.length >= 3 ){    
                let messageBody:IMessageSender  = {
                    type:'getAssetNames',
                    userId: auth.username,
                    data: input
                }
                if(formInput.assetType !== ""){
                    messageBody.assetType = formInput.assetType
                } 
                /*axios.post('/message',messageBody *//*For Cookie*/
                axios.post('/message',messageBody, auth.header
                ).then(res => {                                
                    if(res.data.status === "OK"){
                        setAssetNamesArr(res.data.names)
                        if(res.data.names.includes(input)){                                
                            getAssetInfo({assetName: input}) 
                        }else{                            
                            setFieldBlock(false)
                            setFormFieldsValid({
                                ...formFieldsValid,
                                assetName:{
                                    isValid: false,    
                                    displayMessage: false,
                                    message: ""
                                },
                                oldDeviceId:{
                                    isValid: false,    
                                    displayMessage: false,
                                    message: ""
                                },
                            })   
                            if(formInput.oldDeviceId !== ""){
                                setFormInput({
                                    ...formInput,
                                    assetName: input,
                                    oldDeviceId: "",
                                })
                            }
                            setOldDeviceIdArr([]);
                        }
                    }else{
                        setFieldBlock(false)
                        setAssetNamesArr([])     
                        setFormFieldsValid({
                            ...formFieldsValid,
                            assetName:{
                                isValid: false,    
                                displayMessage: true,
                                message: res.data.errorDescription
                            }
                        })
                    }
                }).catch(({response}:IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status)
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                    })
            }else{
                setAssetNamesArr([])
                setFormFieldsValid({
                    ...formFieldsValid,
                    assetName:{
                        isValid: false,    
                        displayMessage: false,
                        message: ""
                    }
                })
            }
            setFormInput({
            ...formInput,
            assetName: input
            })
        }
    };
    const getAssetInfo = (assetInfoData:{}):void => {        
        const messageBody:IMessageSender  = {
            type: 'getAssetInfo',
            userId: auth.username,
            assetInfo: assetInfoData
        }        
        axios.post('/message',messageBody, auth.header
        ).then(({ data }: {data :IMessageResponse})  =>{
            if(data.status === "OK"){
                let assetInfo =data.assetInfo
                if(assetInfo){                    
                    setFormInput({
                        ...formInput,
                        assetName: data.assetInfo.assetName,
                        assetType: assetInfo.assetType ? assetInfo.assetType : "",
                        oldDeviceId: data.assetInfo.deviceId,
                    })
                    setDefaultSelect(data.assetInfo.assetType)               
                    setFormFieldsValid({
                        ...formFieldsValid,
                        assetName: {
                         isValid: true,
                         displayMessage: false,
                         message: ""
                        },
                        assetType:{
                            isValid: true,
                            displayMessage: false,
                            message: ""
                        },
                        oldDeviceId: {
                         isValid: true,
                         displayMessage: false,
                         message: ""
                        },
                    })
                    setFieldBlock(true);
                }    
            }else{                
                if(Object.keys(assetInfoData)[0] === "assetName"){
                    setFormFieldsValid({
                        ...formFieldsValid,
                        assetName:{
                            isValid: false,
                            displayMessage: true,
                            message: data.errorDescription
                            }
                    })
                }else{
                    setFormFieldsValid({
                        ...formFieldsValid,
                        oldDeviceId:{
                            isValid: false,
                            displayMessage: true,
                            message: data.errorDescription
                            }
                    })
                }
            }
        }).catch(({response}:IMessageErrorResponse) => {
            const errorMessage = errorHandler(response.data.status)
            setErrorMessage(errorMessage)
            setDisplayMessage("error");
          })
    }
    const selectChangeHandler = (e: React.ChangeEvent<HTMLSelectElement>):void =>  {
        let name = e.target.name;        
        setFormInput({
        ...formInput,
        [name]: e.target.value,
        });
        if(name === "assetType"){
            setDefaultSelect(e.target.value)   
        }else{
            setFormFieldsValid({
                ...formFieldsValid,
                oldDeviceIdStatus: {
                    isValid: true,
                    displayMessage: false,
                    message: ""
                }
            })
        }
    }; 
    const newTrackerChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value.toUpperCase();
        if (/^[0-9a-fA-F]+$/.test(input) || input === "") {
            setFormInput({
            ...formInput,
            newDeviceId: input
            })
            if(input.length >= 3){
                let messageBody:IMessageSender  = {
                    type: 'getDeviceIDs',
                    userId: auth.username,
                    deviceIdFilter: {
                      Type: "Unassigned Trackers",
                      Pattern: input,
                    }
                  }
                /*axios.post('/message',messageBody *//*For Cookie*/
                axios.post('/message',messageBody, auth.header
                ).then(res => {                                
                    if(res.data.status === "OK"){
                        setNewDeviceIdArr(res.data.names)
                        setFormFieldsValid({
                            ...formFieldsValid,
                            newDeviceId:{
                                ...formFieldsValid.newDeviceId,
                                displayMessage: false,
                                message: ""
                            }
                        })
                        if(res.data.names.includes(input)){
                            setFormFieldsValid({
                                ...formFieldsValid,
                                newDeviceId:{
                                    isValid:true,
                                    displayMessage: false,
                                    message: ""
                                }
                            })
                        }else{
                            setFormFieldsValid({
                                ...formFieldsValid,
                                newDeviceId:{
                                    isValid:false,
                                    displayMessage: false,
                                    message: ""
                                }
                            })
                        }
                    }else{
                    setNewDeviceIdArr([])
                    setFormFieldsValid({
                        ...formFieldsValid,
                        newDeviceId:{
                            isValid:false,
                            displayMessage: true,
                            message: res.data.errorDescription
                        }
                    })
                    }
                }).catch(({response}:IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status)
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                  })
            }else{
                setNewDeviceIdArr([])
                setFormFieldsValid({
                    ...formFieldsValid,
                    newDeviceId:{
                        isValid:false,
                        displayMessage: false,
                        message: ""
                    }
                })
            }
        };
    }
    
    return (
        <form className="form-template" onSubmit={submitHandler}>
            <div className='form-template-top-container'>
                <div className="form-template-internal-div">
                    <FormTemplateLabel id='assetType' label="Asset Type" dataToolTip='Optional. Filter assets by type to narrow search' />
                    <div className='form-template-input-div-without-icon' >
                        <select className="form-template-input-select" 
                                name="assetType" id="assetType" 
                                onChange={selectChangeHandler}
                                disabled={filedBlock? true : isDisabled()}
                            >
                                <option selected={defaultSelect === ""? true : false}
                                    className="form-template-select-option" value=""
                                >Please choose type... </option>
                                {configuration?.assetTypes.map((assetType, i) => {
                                    if(defaultSelect === assetType){
                                        return <option selected className="form-template-select-option" 
                                                    value={assetType}>{assetType}
                                                </option>    
                                    }else{
                                        return <option className="form-template-select-option" value={assetType}>{assetType}</option> 
                                    }
                                }
                                    
                                )}
                        </select>
                    </div>
                    <FormErrorDivTemplate displayMessage={formFieldsValid.assetType.displayMessage} message={formFieldsValid.assetType.message}/>
                </div>
                < FormInternalDivTemplate
                    id="assetName"
                    label="Asset Name *"
                    type="list"
                    value={formInput.assetName}
                    maxLength={32}
                    displayMessage={formFieldsValid.assetName.displayMessage}
                    message={formFieldsValid.assetName.message}
                    onChange={assetNameChangeHandler}
                    listId="assetsNamesId"
                    array={assetNamesArr}
                    disabled={isDisabled()}
                />
                < FormInternalDivTemplate
                    id="oldDeviceId"
                    label="Old Tracker ID *"
                    type="list"
                    value={formInput.oldDeviceId}
                    maxLength={8}
                    displayMessage={formFieldsValid.oldDeviceId.displayMessage}
                    message={formFieldsValid.oldDeviceId.message}
                    onChange={oldDeviceIdChangeHandler}
                    listId="oldDevicesId"
                    array={oldDeviceIdArr}
                    disabled={isDisabled()}
                />
                < FormInternalDivTemplate
                    id="newDeviceId"
                    label="New Tracker ID *"
                    type="list"
                    value={formInput.newDeviceId}
                    maxLength={8}
                    displayMessage={formFieldsValid.newDeviceId.displayMessage}
                    message={formFieldsValid.newDeviceId.message}
                    onChange={newTrackerChangeHandler}
                    listId="newDevicesId"
                    array={newDeviceIdArr}
                    disabled={isDisabled()}
                />
                 <div className="form-template-internal-div">
                        <FormTemplateLabel id='oldDeviceIdStatus' label="Old Tracker Status *" dataToolTip='Select new status for the replaced device' />
                        <div className='form-template-input-div-without-icon' >
                            <select className="form-template-input-select" 
                                name="oldDeviceIdStatus" 
                                id="oldDeviceIdStatus" 
                                onChange={selectChangeHandler}
                                disabled={isDisabled()}
                            >
                                <option disabled  selected className="form-template-select-option" value="">Please choose type...</option>
                                <option className="form-template-select-option" value="Fault" > Fault </option>
                                <option className="form-template-select-option" value="Spare" > Spare </option>
                            </select>
                        </div>
                        <FormErrorDivTemplate displayMessage={formFieldsValid.oldDeviceIdStatus.displayMessage} message={formFieldsValid.oldDeviceIdStatus.message}/>
                    </div>
            </div>
            <FormSubmitButton text="Replace" disabled={isDisabled()} />  
        </form>
    );
}

export default ReplaceTrackerForm;